function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9211 2H13.8574C13.307 2 12.7667 2.22 12.3864 2.61L2.61032 12.38C1.79981 13.19 1.79981 14.52 2.61032 15.33L8.67411 21.39C9.06435 21.78 9.59469 22 10.145 22C10.6954 22 11.2257 21.78 11.6159 21.39L21.3921 11.62C21.7823 11.23 22.0024 10.7 22.0024 10.15V4.08C22.0024 2.93 21.0619 2 19.9111 2H19.9211ZM19.9812 10.21L10.2051 19.98C10.2051 19.98 10.115 20.01 10.085 19.98L4.0212 13.92C4.0212 13.92 3.99118 13.83 4.0212 13.8L13.8574 4H19.9211C19.9211 4 20.0112 4.04 20.0112 4.08L19.9812 10.2V10.21ZM18.2701 6.8C18.2701 7.39 17.7898 7.87 17.1994 7.87C16.6091 7.87 16.1288 7.39 16.1288 6.8C16.1288 6.21 16.6091 5.73 17.1994 5.73C17.7898 5.73 18.2701 6.21 18.2701 6.8Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=Tag.js.map